export default "__VITE_ASSET__0362f23c__"